import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

export default function StatCard({ icon, label, value, color = '#fec958' }) {
  return (
    <Paper sx={{ p: 2.5, borderRadius: 3, flex: 1, minWidth: 150, border: '1px solid #e8eaf0', boxShadow: 'none' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {/* <Box sx={{ width: 40, height: 40, borderRadius: 2, bgcolor: `${color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', color }}>
          {icon}
        </Box> */}
        <Box>
          <Typography variant="h5" fontWeight={'bold'}>{value}</Typography>
          <Typography variant="caption" color="text.secondary">{label}</Typography>
        </Box>
      </Box>
    </Paper>
  );
}
